import { render, staticRenderFns } from "./Accotation.vue?vue&type=template&id=12a96e1a"
import script from "./Accotation.vue?vue&type=script&lang=js"
export * from "./Accotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports